export default __webpack_public_path__ + "atomic/_patterns/02-molecules/youtube-modal/_youtube-modal.twig";